import StaffAssignedIcon from 'components/elements/icons/StaffAssignedIcon'
import InformationContent from 'components/elements/items/InformationContent'
import RequestedTemplate from 'components/templates/RequestedTemplate'
import React from 'react'
import { QnStatesProps } from 'states/QnState'
import { StatesProps } from 'utils/commonHooks'
import { useServiceEndProcess } from '../../utils/commonHooks'
import { QnStateProps } from '../../states/QnState'

/**
 * QN-12: 案内非対応画面
 */
const NoGuide: React.FC<StatesProps> = (props: QnStatesProps) => {
  const [qnStateProps] = React.useState<QnStateProps>({
    ...props.state,
  })
  useServiceEndProcess(props)

  return (
    <RequestedTemplate
      title={'案内非対応画面'}
      content={
        <InformationContent
          items={[
            {
              icon: <StaffAssignedIcon />,
              marginBottom: '15px',
            },
            {
              message: 'スタッフが見つかりました',
              large: true,
            },
            {
              message:
                '到着予定時間は後ほどお電話いたします。\n画面を閉じて安全な場所でお待ちください。',
              small: true,
            },
          ]}
        />
      }
      state={qnStateProps}
    />
  )
}

export default NoGuide
